export default "__VITE_PUBLIC_ASSET__06bdbb00__"